module.exports = __webpack_public_path__ + "kudos_85.svg?eca5987cedca29a41b6ac72ebbcb052a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_85.svg
// module id = 189
// module chunks = 0